<template>
	<v-card rounded="xl" class="pa-2">
		<loader :dialog="loading"></loader>

		<div class="cl-header">
			<div class="cl-icon-box">
				<v-icon size="18" color="white">mdi-account-group</v-icon>
			</div>
			<div>
				<p class="cl-title">Attribution du protocole</p>
				<p class="cl-subtitle">Sélectionnez les clients</p>
			</div>
		</div>

		<v-divider></v-divider>

		<v-card-text class="pt-4">
			<v-text-field
				v-model="search"
				label="Rechercher un client..."
				prepend-inner-icon="mdi-magnify"
				outlined
				dense
				rounded
				clearable
				hide-details
				class="mb-3"
			></v-text-field>

			<v-list class="cl-list">
				<v-list-item-group
					v-model="customerProtocols"
					active-class="cl-active"
					multiple
				>
					<template v-for="(client, index) in filteredItems">
						<v-list-item
							:key="'A' + index"
							:value="client._id"
							class="cl-item"
						>
							<template v-slot:default="{ active }">
								<div class="cl-avatar">
									{{ initials(client.fullName) }}
								</div>
								<div class="cl-info">
									<p class="cl-name">{{ client.fullName }}</p>
									<p class="cl-meta">
										{{ client.weight }} kg —
										{{ client.height }} m
									</p>
								</div>
								<v-icon
									:color="active ? '#c62828' : '#d1d5db'"
									size="20"
								>
									{{
										active
											? "mdi-checkbox-marked-circle"
											: "mdi-checkbox-blank-circle-outline"
									}}
								</v-icon>
							</template>
						</v-list-item>
						<v-divider
							v-if="index < filteredItems.length - 1"
							:key="index"
						></v-divider>
					</template>
				</v-list-item-group>
			</v-list>
		</v-card-text>

		<v-card-actions class="pa-4 pt-0">
			<v-btn text color="error" rounded @click="$emit('close-client-dialog')">
				Fermer
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				depressed
				rounded
				class="cl-confirm-btn"
				:disabled="customerProtocols.length === 0"
				@click="singleProtocolAttribution"
			>
				<v-icon left small>mdi-check</v-icon>
				Confirmer ({{ customerProtocols.length }})
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import service from "@/services";
import Loader from "@/components/Loader.vue";
export default {
	components: { Loader },
	props: ["protocolId"],
	data() {
		return {
			loading: false,
			search: "",
			customerProtocols: [],
			clients: [],
		};
	},
	computed: {
		filteredItems() {
			return this.clients.filter((item) =>
				item.fullName
					.toLowerCase()
					.includes(this.search.toLowerCase())
			);
		},
	},
	mounted() {
		this.showClients();
	},
	methods: {
		initials(name) {
			if (!name) return "?";
			return name
				.split(" ")
				.slice(0, 2)
				.map((n) => n[0])
				.join("")
				.toUpperCase();
		},
		showClients() {
			this.loading = true;
			service
				.getClients()
				.then((response) => {
					this.clients = response.data;
					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		singleProtocolAttribution() {
			this.loading = true;
			service
				.singleProtocolAttribution(
					this.protocolId,
					this.customerProtocols
				)
				.then(() => {
					this.loading = false;
					this.customerProtocols = [];
					this.$emit("successful-attribution");
				})
				.catch((err) => {
					console.log(err);
					this.loading = false;
				});
		},
	},
};
</script>

<style scoped>
.cl-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.cl-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.cl-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.cl-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.cl-list {
	background: transparent !important;
	max-height: 320px;
	overflow-y: auto;
}
.cl-item {
	border-radius: 10px !important;
	margin-bottom: 2px;
	padding: 8px 12px !important;
	min-height: unset !important;
	display: flex;
	align-items: center;
	gap: 12px;
}
.cl-active {
	background: rgba(198, 40, 40, 0.06) !important;
}
.cl-avatar {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: linear-gradient(135deg, #c62828, #1565c0);
	color: white;
	font-size: 0.65rem;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	font-family: Montserrat, sans-serif;
}
.cl-info {
	flex: 1;
}
.cl-name {
	font-size: 0.85rem;
	font-weight: 600;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.cl-meta {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.cl-confirm-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
</style>

